import { createAction, props } from '@ngrx/store';
import { MgError } from '../../models/error.model';
import { GetDocumentIdRequest } from './document-id.model';

export enum DocumentIdActions {
  getGetDocumentId = '[Enumeration] getGetDocumentId',
  getGetDocumentIdSuccess = '[Enumeration] getGetDocumentIdSuccess',
  getGetDocumentIdFailed = '[Enumeration] getGetDocumentIdFailed',
}

export const GetDocumentId = createAction(
  DocumentIdActions.getGetDocumentId,
  props<{ getDocumentIdRequest: GetDocumentIdRequest }>()
);

export const GetDocumentIdSuccess = createAction(
  DocumentIdActions.getGetDocumentIdSuccess,
  props<{ getDocumentIdResponse: any }>()
);

export const GetDocumentIdFailed = createAction(
  DocumentIdActions.getGetDocumentIdFailed,
  props<{ error: MgError }>()
);
